/**
 * RoleGuard — kuvab "Funktsionaalsus ei ole kasutajale avatud" sõnumi,
 * kui praeguse kasutaja roll ei ole admin (või muu nõutud roll).
 *
 * Kasutus:
 *   <RoleGuard requiredRole="admin">
 *     <SchedulePage ... />
 *   </RoleGuard>
 *   <RoleGuard requireSuper>  — ainult superadmin (globaalsed/süsteemi lehed)
 *
 * Copyright (c) 2025 Rohepaneel
 */
import { useAuth } from '../contexts/AuthContext';

export function RoleGuard({ requiredRole = 'admin', requireSuper = false, children }) {
  const { user } = useAuth();
  if (requireSuper ? user?.is_superadmin : user?.role === requiredRole) return children;

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      background: '#f5f7fb',
      minHeight: '60vh',
    }}>
      <div style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: '480px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          background: '#fef3c7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '32px',
        }}>
          🔒
        </div>
        <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#0f172a', margin: '0 0 8px' }}>
          Funktsionaalsus ei ole kasutajale avatud
        </h2>
        <p style={{ fontSize: '14px', color: '#64748b', margin: 0, lineHeight: 1.6 }}>
          Selle lehe vaatamiseks on vaja kõrgemat õigustetaset.
          Pöördu administraatori poole, kui vajad ligipääsu.
        </p>
        {user?.username && (
          <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '24px', marginBottom: 0 }}>
            Sees logitud: {user.username} <span style={{ opacity: 0.6 }}>({user.role || 'operator'})</span>
          </p>
        )}
      </div>
    </div>
  );
}
